<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>assignment</mat-icon></div>
          <mat-card-title>
            Plano
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <form [formGroup]="formulario" (ngSubmit)="submit()">
            <app-plano-cadastro [formulario]="formulario" [segmentos]="segmentos"
              [funcionalidades]="funcionalidades"></app-plano-cadastro>

            <div class="wow-form-acoes">
              <button type="button" mat-stroked-button (click)="voltarConsulta()">
                <mat-icon>arrow_back</mat-icon> Voltar
              </button>
              <button type="button" mat-stroked-button (click)="limpar()">
                <mat-icon>clear</mat-icon> Limpar
              </button>
              <button type="button" mat-stroked-button color="accent"
                *ngIf="segmentoWowVe && formulario.value.id"
                [disabled]="sincronizandoWowve"
                (click)="sincronizarWowve()">
                <mat-icon>cloud_upload</mat-icon>
                {{ formulario.get('wowveId')?.value ? 'Atualizar no WOW.ve' : 'Publicar no WOW.ve' }}
              </button>
              <button type="submit" mat-raised-button color="primary" [disabled]="!formulario.valid">
                <mat-icon>save</mat-icon> Salvar
              </button>
            </div>
          </form>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
